import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, NumberInput, type NumberInputProps } from '@mantine/core'
import clsx from 'clsx'

import { type CoreProduct } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { useStoreBasket } from '../../hooks/useStoreBasket'
import styles from './styles.module.css'

export type InputQuantityProps = NumberInputProps & {
  product?: CoreProduct
}

export function InputProductQuantity({ product, ...props }: InputQuantityProps) {
  if (!product) {
    return
  }

  const { getBasketProduct, increaseQuantity, setQuantity, decreaseQuantity } =
    useStoreBasket()
  const basketProduct = getBasketProduct(product)

  const classes = clsx(styles.input, props.className, {
    [styles.hasQuantity]: (basketProduct?.quantity ?? 0) > 0,
  })

  return (
    <NumberInput
      {...props}
      value={basketProduct?.quantity ?? 0}
      min={1}
      size='sm'
      onChange={(value) => setQuantity(product, Number(value))}
      className={classes}
      onClick={(e) => e.stopPropagation()}
      leftSection={
        <ActionIcon
          variant='light'
          size='xs'
          h={20}
          w={20}
          radius={4}
          onClick={(e) => {
            e.stopPropagation()
            decreaseQuantity(product)
          }}
        >
          <Icon icon={faMinus} size='xs' />
        </ActionIcon>
      }
      rightSection={
        <ActionIcon
          variant='light'
          size='xs'
          mr='sm'
          h={20}
          w={20}
          radius={4}
          onClick={(e) => {
            increaseQuantity(product)
            e.stopPropagation()
          }}
        >
          <Icon icon={faPlus} size='xs' />
        </ActionIcon>
      }
    />
  )
}
